import Axios from 'axios'
let axios = Axios.create()
let axiosRaw = Axios.create()

axios.interceptors.response.use((response)=>{
    if( response instanceof Error ){
        return Promise.reject(response.message)
    }else{
        return Promise.resolve(response.data)
    }
})

axiosRaw.interceptors.response.use((response)=>{
    if( response instanceof Error ){
        return Promise.reject(response)
    }else{
        return Promise.resolve(response)
    }
})

export default {
    client: {
        indicators: {
            getManagementIndicators: (idClient, initDate, finishDate) =>
                axios.get(`/api/indicators/${idClient}/search?init_date=${initDate}&finish_date=${finishDate}`),
            getSummaryIndicatorsPeriod: (idClient, period, year) => 
                axios.get(`/api/indicators/${idClient}/summary-search?month=${period}&year=${year}`),
            getStats: (idClient, initDate, finishDate) =>
                axios.get(`/api/indicators/${idClient}/get-stats?init_date=${initDate}&finish_date=${finishDate}`)
        }
    },

    acta: {
        indicators: {
            getActaPreview: (idInventario) => 
                axios.get(`/api/preview-acta/${idInventario}`),
            showActa: (idInventario) => 
                axios.get(`/api/show-acta/${idInventario}`),
            getImagenes: (idInventario) =>
                axios.get(`/api/get-imagenes/${idInventario}`),
            getChecklist: (idInventario) =>
                axios.get(`/api/get-checklist/${idInventario}`),
        }
    }
}


// WEBPACK FOOTER //
// ./frontEnd/home/services/homeService.js